export function errMsg(e: unknown): string {
	const x = e as { response?: { data?: { error?: { message?: string } } }; message?: string }
	return x?.response?.data?.error?.message || x?.message || 'Ошибка'
}
